/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `velocity` - velocity
 * * `sommerfeldt` - sommerfeldt
 * * `riemann` - riemann
 * * `water_level` - water_level
 * * `discharge` - discharge
 * @export
 */
export const BoundaryConditionTypeEnum = {
  VELOCITY: "velocity",
  SOMMERFELDT: "sommerfeldt",
  RIEMANN: "riemann",
  WATER_LEVEL: "water_level",
  DISCHARGE: "discharge",
} as const;
export type BoundaryConditionTypeEnum =
  (typeof BoundaryConditionTypeEnum)[keyof typeof BoundaryConditionTypeEnum];

export function instanceOfBoundaryConditionTypeEnum(value: any): boolean {
  for (const key in BoundaryConditionTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(BoundaryConditionTypeEnum, key)) {
      if (BoundaryConditionTypeEnum[key as keyof typeof BoundaryConditionTypeEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function BoundaryConditionTypeEnumFromJSON(json: any): BoundaryConditionTypeEnum {
  return BoundaryConditionTypeEnumFromJSONTyped(json, false);
}

export function BoundaryConditionTypeEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BoundaryConditionTypeEnum {
  return json as BoundaryConditionTypeEnum;
}

export function BoundaryConditionTypeEnumToJSON(value?: BoundaryConditionTypeEnum | null): any {
  return value as any;
}

export function BoundaryConditionTypeEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): BoundaryConditionTypeEnum {
  return value as BoundaryConditionTypeEnum;
}
